import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }
});
export const figure45 = {
  chart: {
      zoomType: 'xy',
      animation: false,
      marginTop: 50,
      marginLeft: 300,
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'bar',
      height: '600px',
      backgroundColor: 'rgba(255, 255, 255, 0.0)',
      style: {
          fontFamily: 'Montserrat'
      }
  },
  colors: ['#ed7d31','#5b9bd5'],
  credits: {
      enabled: false
  },
  title: {
      text: null
  },
  subtitle: {
      text: null
  },
  plotOptions: {
    bar: {
      dataLabels: {
          enabled: true
      }
  },
    series: {
      borderWidth: 0,
      marker: {
        symbol: 'circle',
        enabled: false,
        states: {
          hover: {
            enabled: true,
            radius: 5
          }
        }
      }
    }
  },
  exporting: {
      enabled: false
  },
  xAxis: [{
      tickWidth: 0,
      labels: {
          groupedOptions: [{
                      style: {
                          transform: 'unset'
                      },
                }],
          style: {
            
              transform: 'translateX(5px)'
          },
          align: 'right'
      },
      categories: [
          {
              name: "Monde",
              categories: ["2020", "2015"]
          },
          {
              name: 'Petits États insulaires <br/> en développement (PEID)',
              categories: ["2020", "2015"]
          },
          {
              name: "Pays les <br/>moins avancés (PMA)",
              categories: ["2020", "2015"]
          },
          {
              name: "Pays en développement<br/>sans littoral (PDSL)",
              categories: ["2020", "2015"]
          },
          {
              name: "Régions en développement",
              categories: ["2020", "2015"]
          },
          {
              name: "Régions développées",
              categories: ["2020", "2015"]
          },
      ],
      //labels: {
      //    style: {
      //        align: 'left'
      //    },
      //},
      lineColor: "#d7d7d7",
      tickColor: "#d7d7d7",
      tickLength: 16,
    
  }],

  yAxis: [{
      labels: {
          style: {
              fontWeight: 'normal',
              color: '#999999',
              fontSize: '12px'
          },
      },
      	format: '{value}',
      gridLineWidth: 2,

      max: 80,
      min: 0,
      tickInterval: 10,
      title: {
          text: null,
          style: {
              color: Highcharts.getOptions().colors[1]
          }
      }
  }],
  tooltip: {
      shared: true,
      useHTML: true,
      hideDelay: 500,
      backgroundColor: null,
      borderWidth: 0,
      shadow: false,
      valueSuffix: '',
      style: {
          padding: 0
      }
  },
  legend: {
      enabled: false,
  },
  series: [{
    name: 'Tous types de produits',
    dataLabels: {
      enabled: true,
      style: {
        fontWeight: 'normal',
        textOutline: false,
        color: '#999999',
        fontSize: '12px'
      }
    },
    data: [  55.8, 50.5,
	   70.5, 62.2,
	   63.8, 63.8,
	   72.4, 72.7,
	   53.1, 49.4,
	   57.9, 51.2 ],
  },
  {
    name: 'Agriculture',
    dataLabels: {
      enabled: true,
      style: {
        fontWeight: 'normal',
        textOutline: false,
        color: '#999999',
        fontSize: '12px'
      }
    },
    data:[ 53.8 , 47.7,
	  72.3, 62.4,
	  72.3, 69.0,
	  72.2 , 72.5,
	  54.5, 50.7,
	  53.3, 45.3, ] 
  }
]
  
}
